export default {
  lanhelpdesk: {
    en: 'LanHelpdesk',
    sk: 'LanHelpdesk',
    cz: 'LanHelpdesk',
    de: 'LanHelpdesk',
  },
}
